<template>
  <div>
    <b-form @submit.prevent="submit" novalidate>
      <div class="row">
        <div class="col-lg-12">
          <label>Teenuse nimi:</label>
          <div>{{service.name}}</div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col">
          <validated-form-input name="price" label="Ühiku hind" placeholder="Hind" v-model="price"
                                validate="required|decimal|min_value:0" :decimal="true" :validator="$validator"/>
        </div>
        <div class="col">
          <validated-form-input name="quantity" label="Kogus" placeholder="Kogus" v-model="quantity"
                                validate="required|decimal|min_value:0" :decimal="true" :validator="$validator"/>
        </div>
        <div class="col" v-if="!hideDiscount">
          <validated-form-input name="discount" label="Soodustuse %" placeholder="%" v-model.number="discount"
                                validate="decimal|max_value:100|min_value:0" :decimal="true" :validator="$validator"/>
        </div>
        <div class="col" v-if="!hideVat">
          <validated-form-input name="discount" label="KM %" placeholder="KM määr" v-model.number="vat"
                                validate="required|numeric|max_value:100|min_value:0" :validator="$validator"/>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <submit-button class="float-right" variant="primary">Salvesta</submit-button>
        </div>
      </div>
    </b-form>
  </div>

</template>

<script>
  import ValidatedFormInput from '@/components/ValidatedFormInput'

  export default {
    props: ['service', 'hideVat', 'hideDiscount'],
    components: {ValidatedFormInput},
    data() {
      return {
        price: this.service.price,
        quantity: this.service.quantity,
        discount: this.service.discount,
        vat: this.service.vat
      }
    },
    methods: {
      submit() {
        this.$validator.validateAll().then((valid) => {
          if (!valid) return
          this.service.price = this.price;
          this.service.quantity = this.quantity
          this.service.discount = this.discount
          this.service.vat = this.vat
          this.$emit('done')
        })
      },
    }
  }
</script>
